import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import moment from "moment";
//import { ToastContainer } from 'react-toastify';
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";


import { CampaignAPI } from "./../../../API/Marketing/CampaignAPI";
//import Sidebar from "./../Common/Sidebar";
//import Header from "./../Common/Header";
//import Loader from "./../../Loader";
import Paginate from "./../../../utils/Pagination";
import Layout from "./../Layout";
import ContentLoader from "../../../utils/ContentLoader";
import ReactSelect from 'react-select';
import "./../../../Public/css/leads_list.css";
import { Modal, Button, Offcanvas } from 'react-bootstrap';
import { errorMesg } from "../../Toaster";



const CampaignList = () =>{

    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [pagecount, setPageCount] = useState(0);
    const [totalrecord, setTotalRecords] = useState(0);
    const [sortby, setSortBy] = useState("");
    const [orderby, setOrderBy] = useState("");
    const [filtersStored, setFiltersStored] = useState(null);

    const perpagedata = 20;


    /*useEffect(() => {        

        CampaignsAPI(setCampaigns, setLoading, currentPage, perpagedata, setPageCount);

    }, []);*/

    useEffect(() => {
    
        console.log("Step 1");

        const params = new URLSearchParams();
        
        
        if (filtersStored)
        {
            console.log("Step 3");
                
            Object.keys(filtersStored).forEach(key => {
                if (filtersStored[key]) {
                    params.append(key, filtersStored[key]);
                }
            });
        }

        console.log("Step 4");

        params.append("page", currentPage);
        params.append("per_page", perpagedata);

        console.log(">>>>>" + JSON.stringify(params));

        CampaignAPI(setCampaigns, setLoading, currentPage, perpagedata, setPageCount, setTotalRecords, params);

    }, [currentPage]);

    const handlePageClick = (data) =>{
        setCurrentPage(data.selected + 1);

    }
   

    //console.log('>>>' + JSON.stringify(callers));

    return(
    <Layout>
        <div className="content">
            <div className="row">
                <div className="col-md-12">

                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-8">
                                <h4 className="page-title">Campaigns</h4>
                            </div>
                            <div className="col-4 text-end">
                                <div className="head-icons">
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">                            
                                                       
                            <div className="table-responsive table-wrapper">

                                {loading ?

                                    <ContentLoader />
                                :
                                
                                <table className="table table-wrap" id="">
                                    <thead className="thead-light">
                                        <tr>
                                            <th style={{ width: "30%" }}>Campaign Name</th>
                                            <th style={{ width: "14%" }}>Total Leads</th>
                                            <th style={{ width: "14%" }}>Contacted</th>
                                            <th style={{ width: "14%" }}>Applications</th>
                                            <th style={{ width: "14%" }}>Admissions</th>
                                            <th style={{ width: "14%" }}>Status</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        (campaigns && campaigns.length > 0)  ? 
                                            campaigns?.map(campaign => (
                                                
                                                <tr key={campaign.id}>                                                    
                                                    <td> {campaign.name} </td>
                                                    <td>{campaign.totalcount}</td>                                                         
                                                    <td>{campaign.contactedcount}</td> 
                                                    <td>{campaign.applicationcount}</td>
                                                    <td>{campaign.admissioncount}</td>                                                        
                                                    <td>
                                                        {campaign.status === 1 ?
                                                            <span class="badge badge-pill badge-status bg-success">Active</span>
                                                        :
                                                            (campaign.status === 0 ?
                                                                <span class="badge badge-pill badge-status bg-danger">Deactive</span>
                                                            :
                                                                <span>-</span>
                                                            )
                                                            
                                                        }
                                                    </td>
                                                </tr>
                                            ))
                                        :
                                            null
                                    }
                                    </tbody>
                                </table>
                                }
                                
                            </div>
                            
                            

                        </div>
                    </div>
                    
                    {pagecount > 1 ?
                    <div className="pagination-section mt-3">

                        <nav>
                            <Paginate initialPage={perpagedata} pageCount={pagecount} onPageChange={handlePageClick} />
                        </nav>
                    </div>
                    :
                        <></>
                    }

                </div>
            </div>

        </div>
    </Layout>
    )
}

export default CampaignList;
